'use client';

import { useStore } from '@lib/context/store-context';
import SkeletonProductPage from '@modules/skeletons/templates/skeleton-product-page';
import { useEffect } from 'react';

export default function Loading() {
  const { setLoading } = useStore();
  useEffect(() => {
    setLoading(true);

    return () => {
      setLoading(false);
    };
  }, []);
  return <SkeletonProductPage />;
}
